import React, { Component } from 'react';
import $ from 'jquery';
import Eventpopup from './popup/Eventpopup';
import Eventaddpopup from './popup/Eventaddpopup';
import {
  isMobile
} from "react-device-detect";
import {getUrlVars} from './helper/format';

export default class ChangePasswd extends Component {

  constructor(props)
  {
      super(props);
      this.state = {
        userEmail : null
      }
  }

  componentDidMount()
  {

  }

  change()
  {
    let loginKey = sessionStorage.getItem('loginKey');
    if( loginKey == "" )
    {
      loginKey = localStorage.getItem('loginKey');
    }
    let passwd = $('#passwd').val();
    if( passwd == "" ){
      alert('비밀번호를 입력해주세요');
      return false;
    }
    console.log(loginKey);
    $.post('https://api.tfamily.co.kr/api/account/changePasswd', {
      uk: loginKey,
      passwd: passwd
    } ,function(data){
      let r = JSON.parse(data);
      if( r.error_code == 200 )
      {
          alert('비밀번호가 변경 되었습니다.');
          window.location.href = "/";
      }
      else
      {
          alert('관리자에게 문의 바랍니다.');
      }
    });
  }

  render()
  {
    const self = this;
    return (<div>
      <div className="centralize-wrapper bgGray">
        <div className="centralize-inner">
          <div className="centralize-content">
            <div className="login-box">
              <div className="login-box-body">
                <div className="rowBox">
                  <div className="mlm25">
                     <img className="img-responsive" src={'img/logo.png'} />
                  </div>
                  <div className="row pb30">
                    <span className="redpoint"></span>
                    <h1 className="mb0 mt5"><b>비밀번호 변경</b></h1>
                    <div>비밀번호 변경 페이지 입니다.</div>
                  </div>
                  <form className="mt10">

                    <div className="form-group mt30">
                      <div className="row">
                        <label htmlFor="passwd"><b>변경할 비밀번호</b></label>
                        <input type="password" className="form-control loginform Arial" id="passwd"  placeholder="비밀번호를 입력해주세요"/>
                      </div>
                    </div>
                    <div className="form-group mt30">
                      <div className="row">
                        <a onClick={self.change.bind(this)} className="col-xs-12 btn btn-baru">비밀번호 변경</a>
                      </div>
                      <div className="row">
                        <a href="/" className="col-xs-12 btn btn-select">취소</a>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>);
  }

}
